import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { Minus, Plus, Trash2, ArrowRight } from "lucide-react";
import { useCart } from "../context/CartContext";
import { imageUrl } from "../lib/api";

export default function Cart() {
  const { items, updateQty, removeItem, total } = useCart();
  const navigate = useNavigate();

  if (items.length === 0) {
    return (
      <div className="pt-40 pb-40 text-center">
        <h1 className="font-display text-5xl">Your bag is empty</h1>
        <Link to="/shop" data-testid="empty-shop-btn" className="mt-8 inline-flex items-center gap-2 bg-[hsl(var(--primary))] text-white px-8 py-4 font-body text-sm hover:bg-[hsl(var(--secondary))] transition-colors">
          Browse shirts <ArrowRight className="w-4 h-4" />
        </Link>
      </div>
    );
  }

  return (
    <div className="pt-32 pb-28 max-w-[1200px] mx-auto px-6 md:px-12">
      <h1 className="font-display text-5xl md:text-6xl mb-12">Your bag</h1>
      <div className="grid lg:grid-cols-3 gap-12">
        <div className="lg:col-span-2 border-t border-border" data-testid="cart-items">
          {items.map((it) => (
            <div key={it.key} className="flex gap-5 py-6 border-b border-border" data-testid={`cart-item-${it.product_id}`}>
              <div className="w-24 h-32 bg-muted overflow-hidden shrink-0">
                <img src={imageUrl(it.image)} alt={it.name} className="w-full h-full object-cover" />
              </div>
              <div className="flex-1 flex flex-col justify-between">
                <div>
                  <h3 className="font-display text-2xl leading-tight">{it.name}</h3>
                  {it.size && <p className="overline text-muted-foreground mt-1">Size {it.size}</p>}
                </div>
                <div className="flex items-center gap-4">
                  <div className="flex items-center border border-border">
                    <button onClick={() => updateQty(it.key, it.qty - 1)} className="p-2" data-testid={`qty-dec-${it.product_id}`}><Minus className="w-3.5 h-3.5" /></button>
                    <span className="w-8 text-center font-body text-sm">{it.qty}</span>
                    <button onClick={() => updateQty(it.key, it.qty + 1)} className="p-2" data-testid={`qty-inc-${it.product_id}`}><Plus className="w-3.5 h-3.5" /></button>
                  </div>
                  <button onClick={() => removeItem(it.key)} className="text-muted-foreground hover:text-[hsl(var(--primary))]" data-testid={`remove-${it.product_id}`}><Trash2 className="w-4 h-4" /></button>
                </div>
              </div>
              <div className="font-body font-600 text-right">₹{it.price * it.qty}</div>
            </div>
          ))}
        </div>
        <div className="lg:col-span-1">
          <div className="border border-border p-8 bg-card sticky top-28">
            <h2 className="font-display text-3xl mb-6">Summary</h2>
            <div className="flex justify-between font-body text-sm py-2"><span className="text-muted-foreground">Subtotal</span><span>₹{total}</span></div>
            <div className="flex justify-between font-body text-sm py-2 border-b border-border pb-4"><span className="text-muted-foreground">Shipping</span><span>Free</span></div>
            <div className="flex justify-between font-body font-600 text-lg py-4"><span>Total</span><span data-testid="cart-total">₹{total}</span></div>
            <button onClick={() => navigate("/checkout")} data-testid="checkout-btn"
              className="w-full inline-flex items-center justify-center gap-2 bg-[hsl(var(--primary))] text-white px-8 py-4 font-body text-sm hover:bg-[hsl(var(--secondary))] transition-colors duration-400">
              Checkout <ArrowRight className="w-4 h-4" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
